import * as React from 'react';
import {emotionStyled, tokens} from '@packages/utilities/styled';
import Button from '@packages/systems/design-system/Button';
import TooltipTrigger from '@packages/systems/design-system/TooltipTrigger';

import {IcoPlay12 as PlayIcon} from '@packages/systems/ui/icons';

const IconAndTextWrapper = emotionStyled('div')({
  padding: `0 ${tokens.space[1]}`,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: tokens.space[2],
});

export function FlowRunTestButton({
  openDialog,
  buttonLabel = 'Run test to complete setup',
  intent = 'primary',
  tip = '',
  disabled,
  'data-automation-id': dataAutomationId,
}: {
  /** Handler that opens the Run test dialog modal. */
  openDialog: () => Promise<undefined> | undefined;
  /** Optional button label. Defaults to "Run test to complete setup */
  buttonLabel?: string;
  /** Should the button have a tooltip? Defaults to '' */
  tip?: string;
  /** Should the button be blue (primary) or gray (default)? Defaults to primary */
  intent?: 'default' | 'primary';
  /** Should the button disabled? */
  disabled?: boolean;
  /** Automation ID for E2E tests (e.g. Cypress) */
  ['data-automation-id']?: string;
}) {
  return (
    <TooltipTrigger content={tip} alternate>
      <Button
        data-automation-id={dataAutomationId}
        primary={intent === 'primary'}
        disabled={disabled}
        onClick={openDialog}
      >
        <IconAndTextWrapper>
          <PlayIcon />
          {buttonLabel}
        </IconAndTextWrapper>
      </Button>
    </TooltipTrigger>
  );
}
